module.exports = __webpack_public_path__ + "c0486d16429801e07c9c189e3d420679.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/home/Bitmap.png
// module id = ./assets/images/home/Bitmap.png
// module chunks = 0